__turbopack_context__.v({
  "preview": "index-module-scss-module__3NY7wa__preview",
  "review-box": "index-module-scss-module__3NY7wa__review-box",
  "text": "index-module-scss-module__3NY7wa__text",
});
